import { Accordion } from './Accordion';
import './Tab.css';
export function Tab({ data }) {

  function openTab(evt, tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
  }

  function renderJobs(level) {
    return data?.levels.find((el) => el.id === level).jobs.map((job) => <Accordion name={job.name} key={job.name} content={job.proofs} />)
  }

  function renderTabs() {
    return data?.levels.map((el) => el.jobs.length > 0 && (<button class="tablinks" key={el.id} onClick={(event) => openTab(event, el.id)}>{el.name}</button>));
  }

  function renderTabsContent() {
    return data?.levels.map((el) => (
      <div id={el.id} key={el.id} class="tabcontent">
        <h3>{el.name}</h3>
        {renderJobs(el.id)}
      </div>
    ));
  }
  return (
    <>
      <div class="tab">{renderTabs()}</div>
      {renderTabsContent()}
    </>
  );
}